<template>
  <div>
    <div
      class="group hover:border-primary mx-2 flex cursor-pointer items-center rounded border border-transparent px-2">
      <div class="flex min-w-0 flex-auto">
        <div class="flex-auto overflow-hidden">
          <div class="flex w-full items-center space-x-2">
            <div class="pi pi-comment px-1.5 text-gray-500"></div>
            <div class="truncate overflow-hidden text-nowrap text-ellipsis text-gray-300">
              {{ item.text ?? 'Object' }}
            </div>
          </div>
        </div>
      </div>
      <div class="flex-none">
        <DButton
          text
          size="small"
          class="group-hover:text-primary w-auto p-1.5"
          :class="item.spatial?.annotate ? 'text-gray-300' : 'text-gray-700'"
          @click="
            (event) => {
              event.stopPropagation();
              if (!item.spatial) {
                item.spatial = {};
              }
              item.spatial.annotate = !item.spatial.annotate;
            }
          ">
          <EyeOpen v-if="item.spatial?.annotate" class="h-5 w-5" />
          <EyeClosed v-else class="h-5 w-5"
        /></DButton>
      </div>
    </div>
  </div>
</template>

<script setup>
import { DButton } from '@disguise/cloud-ui';
import { EyeClosed, EyeOpen } from '@disguise/cloud-ui/icons';

const props = defineProps({
  item: Object,
  controlsRef: Object,
});
</script>
